import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";

const WorkTimeClock = ({ currentTotal, heading, stop }) => {
  const [elapsedTime, setElapsedTime] = useState(0);

  // Convert initial currentTotal (HH:MM:SS hrs) → seconds
  useEffect(() => {
    if (currentTotal) {
      const cleanTime = currentTotal.replace("hrs", "").trim();
      const [hours, minutes, seconds = 0] = cleanTime
        .split(":")
        .map((val) => parseInt(val, 10));
      const totalSeconds =
        (hours || 0) * 3600 + (minutes || 0) * 60 + (seconds || 0);
      setElapsedTime(totalSeconds);
    }
  }, [currentTotal]);

  // Handle live ticking, depending on stop value
  useEffect(() => {
    let interval;
    if (stop === false) {
      interval = setInterval(() => {
        setElapsedTime((prev) => prev + 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [stop]);

  // Format as hh:mm:ss
  const hours = String(Math.floor(elapsedTime / 3600)).padStart(2, "0");
  const minutes = String(Math.floor((elapsedTime % 3600) / 60)).padStart(2, "0");
  const seconds = String(elapsedTime % 60).padStart(2, "0");

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 1.5,
        background: stop
          ? "linear-gradient(135deg, #3a3a3a, #555)"
          : "linear-gradient(135deg, #1e1e2f, #2c2c3a)",
        padding: "10px 18px",
        borderRadius: "12px",
        boxShadow: stop
          ? "0 0 8px rgba(255, 100, 100, 0.3)"
          : "0 4px 12px rgba(0,0,0,0.25)",
        color: "#00ffcc",
        fontFamily: "'Orbitron', sans-serif",
        transition: "all 0.3s ease",
      }}
    >
      <Typography
        variant="body2"
        sx={{
          color: "#ffffffa6",
          fontSize: "13px",
          fontWeight: 500,
          letterSpacing: "0.5px",
        }}
      >
        {heading}
      </Typography>

      <Typography
        variant="h6"
        sx={{
          fontWeight: 600,
          letterSpacing: "1px",
          color: stop ? "#ff6b6b" : "#00ffcc",
        }}
      >
        {hours}:{minutes}:{seconds}
        <Typography
          component="span"
          sx={{
            fontSize: "12px",
            color: "#ffffffa6",
            ml: 0.5,
          }}
        >
          hrs
        </Typography>
      </Typography>
    </Box>
  );
};

export default WorkTimeClock;
